import React, {Component} from 'react';

import PageSettingsService from "../../service/PageSettingsService";
import GeneralUtils from "../../utils/GeneralUtils";
import BasketService from "../../service/BasketService";
import {Badge} from "@material-ui/core";

export class AppFooterMemberMobile extends Component {
    constructor() {
        super();
        this.state = {
            numberOfItems: 0,
            totalPriceString: null
        };
        this.pageSettingsService = new PageSettingsService();
        this.basketService = new BasketService();
    }

    componentDidMount = () => {
        this.refreshData();
    }

    refreshData() {
        this.basketService.findBasketCreatedByMerchantBranchId(localStorage.getItem("merchantBranchId"), null).then((response) => {
            this.setDataFromBasket(response);
        });
    }

    setDataFromBasket(response) {
        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
            var numberOfItems = 0;
            const basketDetailList = response.basketDetailList || [];
            for (var i = 0; i < basketDetailList.length; i++) {
                if (basketDetailList[i].parentBssId == null) {
                    if (basketDetailList[i].weighable == false) {
                        numberOfItems = numberOfItems + basketDetailList[i].quantity;
                    } else {
                        numberOfItems = numberOfItems + 1;
                    }
                }
            }
            this.setState({
                numberOfItems: numberOfItems,
                totalPriceString: response.totalPriceString
            });
        }
    }

    render() {
        const buttonText = "View Your Order";
        let totalPrice = "";
        if (this.state.numberOfItems != null && this.state.numberOfItems > 0 && this.state.totalPriceString != null) {
            totalPrice = this.state.totalPriceString;
        }

        const hasItems = this.state.numberOfItems > 0;

        return (
            <footer className="footerMemberMobile">
                <div className="footerMemberMobileInner">
                    <button
                        type="button"
                        className="footerMemberCartButton"
                        onClick={() => this.props.viewcart()}
                    >
                        <span className="footerMemberCartIconWrap" aria-hidden="true">
                            {hasItems ? (
                                <Badge
                                    badgeContent={this.state.numberOfItems}
                                    color="error"
                                    showZero={false}
                                    overlap="rectangle"
                                >
                                    <i className="pi pi-shopping-cart footerMemberCartIcon"></i>
                                </Badge>
                            ) : (
                                <i className="pi pi-shopping-cart footerMemberCartIcon"></i>
                            )}
                        </span>
                        <span className="footerMemberCartLabel">{buttonText}</span>
                        <span className="footerMemberCartTotal">{totalPrice || '\u00a0'}</span>
                    </button>
                </div>
            </footer>
        );
    }
}
